import publicUrls from "../routes/publicUrls";
export const linksData = [

  {
    to: "/home",
    name: "HOME",
    title: "Home",
    handle: "homehandle",
    icon: "fa fa-home",
    class: "",
  },
  {
    to: "/auctions/room",
    title: "Live",
   name: "LIVE AUCTION",
   handle: "handleClickLive",
   icon: 'fa fa-television',
   class: "",
  
 },
  {
    to: "/auctions",
    name: "AUCTIONS",
    title: "Auctions",
    handle: "upcommingEventsHandle",
    icon: 'fa fa-gavel',
    class: "",
    // dropdown: [
    //     to: "/auctions",
    //     name: "UPCOMING AUCTIONS",
    //     handle: "upcommingEventsHandle",
    //   },
    //     to: "/results",
    //     name: "AUCTIONS RESULTS",
    //     handle: "handleResults",
    //   },
    // ],
  },
  {
    to: publicUrls.exhibitions(),
    name: "EXHIBITION",
    title: "Exhibition",
    handle: "handleExhibition",
    icon: "fa fa-picture-o",
    class: ""

  },
  //   PRIVATE SALE  to: "/buy/jewelry?data=JEWELRY", /private-sale/PRIVATE_SALE
  {
  
    to: "#",
    name: "PRIVATE SALE",
    title: "Private Sale",
    handle: "",
    icon: "fa fa-shield",
    class: "dropdown",
    dropdown: [
      {
        to: publicUrls.privateSales(),
        name: "PAINTING",
        handle: "handlePrivatePainting",
        class: "",
      },
      {
        to: publicUrls.privateSales(),
        name: "SCULPTURE",
        handle: "handlePrivateSCULPTURE",
        class: "",
      },
      {
        to: publicUrls.privateSales(),
        name: "FURNITURE",
        handle: "handlePrivateFurniture",
        class: "",
      },
      {
        to: publicUrls.privateSales(),
        name: "JEWELRY",
        handle: "handlePrivateJewelry",
        class: "",
      },
      {
        to: publicUrls.privateSales(),
        name: "OBJET D' ARTS",
        handle: "handlePrivateARTS",
        class: "",
      },
      {
        to: publicUrls.privateSales(),
        name: "MAPS",
        handle: "handlePrivateMAPS",
        class: "",
      },
      {
        to: publicUrls.privateSales(),
        name: "WATCHES",
        handle: "handlePrivateWATCHES",
        class: "",
      },

      {
        to: publicUrls.privateSales(),
        name: "MID-CENTURY",
        handle: "handlePrivateMID-CENTURY",
        class: "",
      },


      {
        to: publicUrls.privateSales(),
        name: "BOOKS",
        handle: "handlePrivateBOOKS",
        class: "",
      },
    ],
  },

  {
    to: "/stories",
    name: "STORIES",
    title: "Stories",
    handle: "handleClickStories",
    icon: "fa fa-book",
    class: "",

  },
  {
    to: "#",
    name: "GALLERIES",
    title: "Galleries",
    // handle: "handleAuctionsRoom",
    icon: "fa fa-building",
    class: "dropdown",
    dropdown: [
      {
        to: publicUrls.location("main"),
        name: "MAIN",
        handle: "handleMain",
        class: "",
      },
      {
        to: publicUrls.location("international"),
        name: "INTERNATIONAL",
        handle: "handleInternational",
        class: "",
      },
      {
        to: publicUrls.location("lafuerza"),
        name: "LA FUERZA",
        handle: "handleLafuerza",
        class: "",
      },
      //   to: "/location/maison",
      //   name: "MAISON",
      //   handle: "handleMaison",
      // },
    ],
  },
  //   to: "/faq",
  //   name: "FAQ",
  //   handle: "handleFaq",
  //   dropdown: [
  //       to: "/how_to_sell",
  //       name: "HOW TO SELL",
  //       handle: "handleHowtosell",
  //     },
  //       to: "/how_to_transfort",
  //       name: "HOW TO TRANSFORT",
  //       handle: "handleHowtotransfort",
  //     },
  //       to: "/where_do_i_go",
  //       name: "WHERE DO I GO",
  //       handle: "handleWhereDO",
  //     },
  //       to: "/how_to_consign",
  //       name: "HOW TO CONSIGN",
  //       handle: "handleHowToConsign",
  //     },
  //   ],
  // }
];
